const archiveContainer = document.querySelector('.ArchiveProduct__container');
const gridListViewButtons = document.querySelectorAll('.grid-list-switch');
const productsListContainer = document.querySelector('.ArchiveProduct .products');

if (archiveContainer) {
    const defaultColumnsNumber = archiveContainer.querySelector('.ArchiveContainer__content')
        .dataset.columns;

    gridListViewButtons.forEach((button) => {
        button.addEventListener('click', () => {
            if (button.dataset.view === 'list') {
                productsListContainer.classList.remove(`columns-${defaultColumnsNumber}`);
                productsListContainer.classList.add('columns-1');
            } else {
                productsListContainer.classList.remove('columns-1');
                productsListContainer.classList.add(`columns-${defaultColumnsNumber}`);
            }
        });
    });

    const openFiltersPanelButton = archiveContainer.querySelector('.toggle-filters');
    const closeFiltersPanelButton = archiveContainer.querySelector('#close-filters');
    const sidebar = archiveContainer.querySelector('.ArchiveProduct__sidebar');

    const openFilters = () => {
        archiveContainer.classList.add('show-filters');
        sidebar.style.display = 'block';
        document.documentElement.style.overflowY = 'hidden';
    };

    const closeFilters = () => {
        archiveContainer.classList.remove('show-filters');
        sidebar.style.display = 'none';
        document.documentElement.style.overflowY = 'auto';
    };

    openFiltersPanelButton.addEventListener('click', () => {
        if (archiveContainer.classList.contains('show-filters')) {
            closeFilters();
        } else {
            openFilters();
        }
    });

    if (closeFiltersPanelButton) {
        closeFiltersPanelButton.addEventListener('click', closeFilters);
    }
}